import React, { useState, useContext } from 'react';
import { useDispatch } from '../../store/index.js';
import { useSelector } from '../../store/index.js';
import { useEffect } from 'react';
import congratulation from "../Animated/congratulation.json";
import rewardAnimation from "../Animated/reward_man_animation.json";
import Lottie from 'lottie-react';
import { ChangePage } from '../../store/reducers/menu.js';

function CongratulationModal() {
    const dispatch = useDispatch();
    const { winValue } = useSelector((state) => state.auth);

    useEffect(() => {
        setTimeout(() => {
            dispatch(ChangePage(""))
        }, 4000)
    }, [])

    return (
        <div className="modal-overlay fixed inset-0 flex items-center justify-center text-white"
        style={{ backgroundColor: "rgba(0,0,0,0.8)" }}>
            <div className="fixed inset-0 flex items-center justify-center">
                <div className="flex w-full flex-col justify-center items-center px-4 relative">
                    <Lottie
                        animationData={rewardAnimation}
                        loop
                        autoPlay
                        style={{
                            width: 300,
                            height: 300,
                        }}
                    />

                    <Lottie
                        className='absolute top-10'
                        animationData={congratulation}
                        loop
                        autoPlay
                        style={{
                            width: 300,
                            height: 300,
                        }}
                    />
                    <span className='text-center font-bold text-yellow-200 text-[30px] md:text-[40px] '>You won! Congratulation !</span>
                    <span className='text-center font-bold text-white text-[30px] md:text-[40px]'>+ ${winValue}</span>
                </div>
            </div>
        </div>
    );
}

export default CongratulationModal;